import {
  LOGIN_USER_DATA_FAILURE,
  LOGIN_USER_DATA_SUCCESS,
  LOGIN_USER_DATA_REQUEST,
  JWT_TOKEN,
  CHAT_MESSAGE,
  ACTIVE_PATIENTS_SUCCESS,
  ACTIVE_PATIENTS_FAILURE,
  ACTIVE_PATIENTS_REQUEST,
  UNCLAIMED_PATIENTS_REQUEST,
  UNCLAIMED_PATIENTS_FAILURE,
  UNCLAIMED_PATIENTS_SUCCESS,
  OTHER_PATIENTS_FAILURE,
  OTHER_PATIENTS_REQUEST,
  OTHER_PATIENTS_SUCCESS,
  QUEUED_PATIENTS_FAILURE,
  QUEUED_PATIENTS_REQUEST,
  QUEUED_PATIENTS_SUCCESS,
  BROADCAST_FILE_DATA_REQUEST,
  BROADCAST_FILE_DATA_SUCCESS,
  BROADCAST_FILE_DATA_FAILURE,
  BROADCAST_MESSAGE_REQUEST,
  BROADCAST_MESSAGE_SUCCESS,
  BROADCAST_MESSAGE_FAILURE,
  LOAD_CHAT_USER_ID_PATIENT_ID_REQUEST,
  LOAD_CHAT_USER_ID_PATIENT_ID_FAILURE,
  LOAD_CHAT_USER_ID_PATIENT_ID_SUCCESS,
  CLAIMED_PATIENT_BY_USER_REQUEST,
  CLAIMED_PATIENT_BY_USER_SUCCESS,
  CLAIMED_PATIENT_BY_USER_FAILURE,
  REVOKE_PATIENT_BY_USER_REQUEST,
  REVOKE_PATIENT_BY_USER_SUCCESS,
  REVOKE_PATIENT_BY_USER_FAILURE,
  SHIFT_ACTIVE_PATIENTS_LIST,
  REORDER_UNCLIAMED_PATIENT_LIST,
  UPDATE_MESSAGE_STATUS_API_CALL,
  UPDATE_OTHER_PATIENT_LIST,
  SEND_UPLOAD_LINK_BY_USER_REQUEST,
  SEND_UPLOAD_LINK_BY_USER_SUCCESS,
  SEND_UPLOAD_LINK_BY_USER_FAILURE,
  UPLOAD_PATIENT_FILES_BY_PATIENT_REQUEST,
  UPLOAD_PATIENT_FILES_BY_PATIENT_SUCCESS,
  UPLOAD_PATIENT_FILES_BY_PATIENT_FAILURE,
  DOWNLOAD_PATIENT_FILES_BY_USER_REQUEST,
  DOWNLOAD_PATIENT_FILES_BY_USER_SUCCESS,
  DOWNLOAD_PATIENT_FILES_BY_USER_FAILURE,
  SEND_DOC_SIGN_LINK_REQUEST,
  SEND_DOC_SIGN_LINK_SUCCESS,
  SEND_DOC_SIGN_LINK_FAILURE,
  DOWNLOAD_SIGNED_DOC_BY_USER_REQUEST,
  DOWNLOAD_SIGNED_DOC_BY_USER_SUCCESS,
  DOWNLOAD_SIGNED_DOC_BY_USER_FAILURE,
  LIVE_AGENT_CHAT_REQUEST,
  LIVE_AGENT_CHAT_SUCCESS,
  LIVE_AGENT_CHAT_FAILURE,
  REVOKE_PATIENT_BY_AGENT_REQUEST,
  REVOKE_PATIENT_BY_AGENT_SUCCESS,
  REVOKE_PATIENT_BY_AGENT_FAILURE,
  CLAIM_CHAT_BY_AGENT_REQUEST,
  CLAIM_CHAT_BY_AGENT_SUCCESS,
  CLAIM_CHAT_BY_AGENT_FAILURE,
  SHIFT_CHAT_LIST,
} from "./actionTypes";

export const FETCH_PATIENT_DATA_REQUEST = "FETCH_PATIENT_DATA_REQUEST";
export const FETCH_PATIENT_DATA_SUCCESS = "FETCH_PATIENT_DATA_SUCCESS";
export const FETCH_PATIENT_DATA_FAILURE = "FETCH_PATIENT_DATA_FAILURE";
export const FETCH_PATIENT_DATA_EMPTY = "FETCH_PATIENT_DATA_EMPTY";
export const FETCH_PATIENT_FOR_CHAT = "FETCH_PATIENT_FOR_CHAT";
/*** Constant to check user */
export const CHECK_USER_DATA_REQUEST = "CHECK_USER_DATA_REQUEST";
export const CHECK_USER_DATA_SUCCESS = "CHECK_USER_DATA_SUCCESS";
export const CHECK_USER_DATA_FAILURE = "CHECK_USER_DATA_FAILURE";

/*** Constant to sign up user */
export const SIGNUP_USER_DATA_REQUEST = "SIGNUP_USER_DATA_REQUEST";
export const SIGNUP_USER_DATA_SUCCESS = "SIGNUP_USER_DATA_SUCCESS";
export const SIGNUP_USER_DATA_FAILURE = "SIGNUP_USER_DATA_FAILURE";

/*** Constant to add patient */
export const ADD_PATIENT_DATA_REQUEST = "ADD_PATIENT_DATA_REQUEST";
export const ADD_PATIENT_DATA_SUCCESS = "ADD_PATIENT_DATA_SUCCESS";
export const ADD_PATIENT_DATA_FAILURE = "ADD_PATIENT_DATA_FAILURE";

/*** Constant to check permission */
export const CHECK_PERMISSION_REQUEST = "CHECK_PERMISSION_REQUEST";
export const CHECK_PERMISSION_SUCCESS = "CHECK_PERMISSION_SUCCESS";
export const CHECK_PERMISSION_FAILURE = "CHECK_PERMISSION_FAILURE";

export const fetch_patient_data_request = () => {
  return {
    type: FETCH_PATIENT_DATA_REQUEST,
  };
};

export const fetch_patient_data_success = (data) => {
  return {
    type: FETCH_PATIENT_DATA_SUCCESS,
    payload: data,
  };
};

export const fetch_patient_data_failure = (data = {}) => {
  return {
    type: FETCH_PATIENT_DATA_FAILURE,
    payload: data,
  };
};

export const fetch_patient_data_empty = (data) => {
  return {
    type: FETCH_PATIENT_DATA_EMPTY,
    payload: data,
  };
};

export const fetch_chat_patient = (data) => {
  return {
    type: FETCH_PATIENT_FOR_CHAT,
    payload: data,
  };
};

/***** check user data **/
export const check_user_data_request = () => {
  return {
    type: CHECK_USER_DATA_REQUEST,
  };
};

export const check_user_data_success = (data) => {
  return {
    type: CHECK_USER_DATA_SUCCESS,
    payload: data,
  };
};

export const check_user_data_failure = (data) => {
  return {
    type: CHECK_USER_DATA_FAILURE,
    payload: data,
  };
};

/***** Signup user  **/
export const signup_user_data_request = () => {
  return {
    type: SIGNUP_USER_DATA_REQUEST,
  };
};

export const signup_user_data_success = (data) => {
  return {
    type: SIGNUP_USER_DATA_SUCCESS,
    payload: data,
  };
};

export const signup_user_data_failure = (data) => {
  return {
    type: SIGNUP_USER_DATA_FAILURE,
    payload: data,
  };
};

/***** Add patient  **/
export const add_patient_data_request = () => {
  return {
    type: ADD_PATIENT_DATA_REQUEST,
  };
};

export const add_patient_data_success = (data) => {
  return {
    type: ADD_PATIENT_DATA_SUCCESS,
    payload: data,
  };
};

export const add_patient_data_failure = (data) => {
  return {
    type: ADD_PATIENT_DATA_FAILURE,
    payload: data,
  };
};

/***
 *
 * Login action
 *
 */
export const login_user_data_request = () => {
  return {
    type: LOGIN_USER_DATA_REQUEST,
  };
};

export const login_user_data_success = (data) => {
  return {
    type: LOGIN_USER_DATA_SUCCESS,
    payload: data,
  };
};

export const login_user_data_failure = (data) => {
  return {
    type: LOGIN_USER_DATA_FAILURE,
    payload: data,
  };
};

/***
 *
 * Check user permission
 *
 */
export const checkPermissionRequest = () => {
  return {
    type: CHECK_PERMISSION_REQUEST,
  };
};

export const checkPermissionSuccess = (data) => {
  return {
    type: CHECK_PERMISSION_SUCCESS,
    payload: data,
  };
};

export const checkPermissionFailure = (data) => {
  return {
    type: CHECK_PERMISSION_FAILURE,
    payload: data,
  };
};

/**
 * JWT TOKEN
 *
 */

export const jwt_token = (data) => {
  return {
    type: JWT_TOKEN,
    payload: data,
  };
};
/**
 * CHAT MESSAGES
 */
export const chatMessageAction = (data) => {
  return {
    type: CHAT_MESSAGE,
    payload: data,
  };
};

/***
 *
 * Broadcast file upload
 *
 */
export const broadcast_file_data_request = () => {
  return {
    type: BROADCAST_FILE_DATA_REQUEST,
  };
};

export const broadcast_file_data_success = (data) => {
  return {
    type: BROADCAST_FILE_DATA_SUCCESS,
    payload: data,
  };
};
export const broadcast_file_data_failure = (data) => {
  return {
    type: BROADCAST_FILE_DATA_FAILURE,
    payload: data,
  };
};
export const active_patients_request = () => {
  return {
    type: ACTIVE_PATIENTS_REQUEST,
  };
};

export const active_patients_success = (data) => {
  return {
    type: ACTIVE_PATIENTS_SUCCESS,
    payload: data,
  };
};

export const active_patients_failure = (data) => {
  return {
    type: ACTIVE_PATIENTS_FAILURE,
    payload: data,
  };
};

/***
 * unclaimed patient
 */
export const unclaimed_patients_request = () => {
  return {
    type: UNCLAIMED_PATIENTS_REQUEST,
  };
};

export const unclaimed_patients_success = (data) => {
  return {
    type: UNCLAIMED_PATIENTS_SUCCESS,
    payload: data,
  };
};

export const unclaimed_patients_failure = (data) => {
  return {
    type: UNCLAIMED_PATIENTS_FAILURE,
    payload: data,
  };
};

/***
 * QUEUED patient
 */
 export const queued_patients_request = () => {
  return {
    type: QUEUED_PATIENTS_REQUEST,
  };
};

export const queued_patients_success = (data) => {
  return {
    type: QUEUED_PATIENTS_SUCCESS,
    payload: data,
  };
};

export const queued_patients_failure = (data) => {
  return {
    type: QUEUED_PATIENTS_FAILURE,
    payload: data,
  };
};

/***
 * Active patient
 */
export const other_patients_request = () => {
  return {
    type: OTHER_PATIENTS_REQUEST,
  };
};

export const other_patients_success = (data) => {
  return {
    type: OTHER_PATIENTS_SUCCESS,
    payload: data,
  };
};

export const other_patients_failure = (data) => {
  return {
    type: OTHER_PATIENTS_FAILURE,
    payload: data,
  };
};

/***
 *
 * Broadcast file upload
 *
 */
export const broadcast_message_request = () => {
  return {
    type: BROADCAST_MESSAGE_REQUEST,
  };
};

export const broadcast_message_data_success = (data) => {
  return {
    type: BROADCAST_MESSAGE_SUCCESS,
    payload: data,
  };
};
export const broadcast_message_data_failure = (data) => {
  return {
    type: BROADCAST_MESSAGE_FAILURE,
    payload: data,
  };
};

/**
 * load chat action creators
 */
export const loadChatUserIdPatientIdRequest = () => {
  return {
    type: LOAD_CHAT_USER_ID_PATIENT_ID_REQUEST,
  };
};

export const loadChatUserIdPatientIdSuccess = (chat) => {
  return {
    type: LOAD_CHAT_USER_ID_PATIENT_ID_SUCCESS,
    payload: chat,
  };
};
export const loadChatUserIdPatientIdError = (errorChat) => {
  return {
    type: LOAD_CHAT_USER_ID_PATIENT_ID_FAILURE,
    payload: errorChat,
  };
};

/**
 * CLAIMED PATIENT BY THE USER
 *
 */
export const claimedPaitentByUserRequest = () => {
  return {
    type: CLAIMED_PATIENT_BY_USER_REQUEST,
  };
};

export const claimedPaitentByUserSuccess = (data) => {
  return {
    type: CLAIMED_PATIENT_BY_USER_SUCCESS,
    payload: data,
  };
};

export const claimedPaitentByUserFailure = (error) => {
  return {
    type: CLAIMED_PATIENT_BY_USER_FAILURE,
    payload: error,
  };
};

/**
 * REVOKE PATIENT BY THE USER
 *
 */
export const revokePaitentByUserRequest = () => {
  return {
    type: REVOKE_PATIENT_BY_USER_REQUEST,
  };
};

export const revokePaitentByUserSuccess = (data) => {
  return {
    type: REVOKE_PATIENT_BY_USER_SUCCESS,
    payload: data,
  };
};

export const revokePaitentByUserFailure = (error) => {
  return {
    type: REVOKE_PATIENT_BY_USER_FAILURE,
    payload: error,
  };
};

/**
 * SEND UPLOAD LINK TO PATIENT BY THE USER
 *
 */
export const sendUploadLinkByUserRequest = () => {
  return {
    type: SEND_UPLOAD_LINK_BY_USER_REQUEST,
  };
};

export const sendUploadLinkByUserSuccess = (data) => {
  return {
    type: SEND_UPLOAD_LINK_BY_USER_SUCCESS,
    payload: data,
  };
};

export const sendUploadLinkByUserFailure = (error) => {
  return {
    type: SEND_UPLOAD_LINK_BY_USER_FAILURE,
    payload: error,
  };
};

/**
 * UPLOAD PATIENT FILES BY PATIENT
 *
 */
export const uploadPatientFilesRequest = () => {
  return {
    type: UPLOAD_PATIENT_FILES_BY_PATIENT_REQUEST,
  };
};

export const uploadPatientFilesSuccess = (data) => {
  return {
    type: UPLOAD_PATIENT_FILES_BY_PATIENT_SUCCESS,
    payload: data,
  };
};

export const uploadPatientFilesFailure = (error) => {
  return {
    type: UPLOAD_PATIENT_FILES_BY_PATIENT_FAILURE,
    payload: error,
  };
};

/**
 * UPLOAD PATIENT FILES BY PATIENT
 *
 */
export const docSignLinkRequest = () => {
  return {
    type: SEND_DOC_SIGN_LINK_REQUEST,
  };
};

export const docSignLinkSuccess = (data) => {
  return {
    type: SEND_DOC_SIGN_LINK_SUCCESS,
    payload: data,
  };
};

export const docSignLinkFailure = (error) => {
  return {
    type: SEND_DOC_SIGN_LINK_FAILURE,
    payload: error,
  };
};

/**
 * DOWNLOAD PATIENT FILES BY PATIENT
 *
 */
export const downloadPatientFilesRequest = () => {
  return {
    type: DOWNLOAD_PATIENT_FILES_BY_USER_REQUEST,
  };
};

export const downloadPatientFilesSuccess = (data) => {
  return {
    type: DOWNLOAD_PATIENT_FILES_BY_USER_SUCCESS,
    payload: data,
  };
};

export const downloadPatientFilesFailure = (error) => {
  return {
    type: DOWNLOAD_PATIENT_FILES_BY_USER_FAILURE,
    payload: error,
  };
};

/**
 * DOWNLOAD PATIENT SIGNED DOCUMENT
 *
 */
export const downloadSignedDocRequest = () => {
  return {
    type: DOWNLOAD_SIGNED_DOC_BY_USER_REQUEST,
  };
};

export const downloadSignedDocSuccess = (data) => {
  return {
    type: DOWNLOAD_SIGNED_DOC_BY_USER_SUCCESS,
    payload: data,
  };
};

export const downloadSignedDocFailure = (error) => {
  return {
    type: DOWNLOAD_SIGNED_DOC_BY_USER_FAILURE,
    payload: error,
  };
};

/**
 * SHIFT ACTIVE PATIENT TO TOP
 */
export const shiftActivePatientToTop = (arrayData) => {
  return {
    type: SHIFT_ACTIVE_PATIENTS_LIST,
    payload: arrayData,
  };
};
/**
 * REORDER UNCLAIMED PATIENTS
 */
export const reorderUnClaimedPatient = (arrayData) => {
  return {
    type: REORDER_UNCLIAMED_PATIENT_LIST,
    payload: arrayData,
  };
};
/***
 * update message status of particular user
 */
export const updateMessageStatusApiCall = (messageIdWithUserId) => {
  return {
    type: UPDATE_MESSAGE_STATUS_API_CALL,
    payload: messageIdWithUserId,
  };
};
/***
 * update other patients
 */
export const updateOtherPatientsList = (arrayData) => {
  return {
    type: UPDATE_OTHER_PATIENT_LIST,
    payload: arrayData,
  };
};

/***
 * Active chats
 */
export const live_agent_chat_request = () => {
  return {
    type: LIVE_AGENT_CHAT_REQUEST,
  };
};

export const live_agent_chat_success = (data) => {
  return {
    type: LIVE_AGENT_CHAT_SUCCESS,
    payload: data,
  };
};

export const live_agent_chat_failure = (data) => {
  return {
    type: LIVE_AGENT_CHAT_FAILURE,
    payload: data,
  };
};

/**
 * REVOKE CLIENT BY THE AGENT
 *
 */
export const revokePatientByAgentRequest = () => {
  return {
    type: REVOKE_PATIENT_BY_AGENT_REQUEST,
  };
};

export const revokePatientByAgentSuccess = (data) => {
  return {
    type: REVOKE_PATIENT_BY_AGENT_SUCCESS,
    payload: data,
  };
};

export const revokePatientByAgentFailure = (error) => {
  return {
    type: REVOKE_PATIENT_BY_AGENT_FAILURE,
    payload: error,
  };
};

/**
 * CLIAM CHAT BY THE AGENT
 *
 */
export const claimChatByAgentRequest = () => {
  return {
    type: CLAIM_CHAT_BY_AGENT_REQUEST,
  };
};

export const claimChatByAgentSuccess = (data) => {
  return {
    type: CLAIM_CHAT_BY_AGENT_SUCCESS,
    payload: data,
  };
};

export const claimChatByAgentFailure = (error) => {
  return {
    type: CLAIM_CHAT_BY_AGENT_FAILURE,
    payload: error,
  };
};
/**
 * SHIFT CHAT  TO TOP
 */
export const shiftChatToTop = (arrayData) => {
  return {
    type: SHIFT_CHAT_LIST,
    payload: arrayData,
  };
};
